var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportRe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.17262 1.3147V9.29448M8.17262 9.29448L5.5127 6.63455M8.17262 9.29448L10.8326 6.63455",
    stroke: "#6A6A6A",
    strokeWidth: 1.32996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.51333 2.64478H2.8534C2.50067 2.64478 2.16239 2.7849 1.91297 3.03431C1.66356 3.28373 1.52344 3.62201 1.52344 3.97474V10.6246C1.52344 10.9773 1.66356 11.3156 1.91297 11.565C2.16239 11.8144 2.50067 11.9545 2.8534 11.9545H13.4931C13.8458 11.9545 14.1841 11.8144 14.4335 11.565C14.683 11.3156 14.8231 10.9773 14.8231 10.6246V3.97474C14.8231 3.62201 14.683 3.28373 14.4335 3.03431C14.1841 2.7849 13.8458 2.64478 13.4931 2.64478H10.8332",
    stroke: "#6A6A6A",
    strokeWidth: 1.32996,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportRe);
export default __webpack_public_path__ + "static/media/ImportRe.7d8a4e6f9436f3a37de908e1f8cede41.svg";
export { ForwardRef as ReactComponent };